import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Switch,
} from "@mui/material";
import React, { useState } from "react";

interface ConfirmationStepProps {
  title: string;
  count: number;
  isUseV2: boolean;
  processed: number | null;
  enableCache?: boolean;
  onEnableCacheChange?: (enabled: boolean) => void;
  featureType: string;
}

export const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  title,
  count,
  isUseV2,
  processed,
  enableCache = true,
  onEnableCacheChange,
  featureType,
}) => {
  return (
    <Stack spacing={2} sx={{ paddingBottom: "10px" }}>
      <Typography sx={{ textAlign: "center" }}>
        {isUseV2 && enableCache && featureType === "ORDER_GUIDE"
          ? `You’re about to import ${count} modified ${title.toLowerCase()} records. Proceed?`
          : `You’re about to import ${count} ${title.toLowerCase()} records. Proceed?`}
      </Typography>
      {processed !== null && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={20} />
          <Typography>Processing {processed} data</Typography>
        </Box>
      )}
      {isUseV2 && featureType === "ORDER_GUIDE" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Stack spacing={1} sx={{ alignItems: "center" }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="radio"
                    id="import-all"
                    checked={!enableCache}
                    onChange={() => onEnableCacheChange?.(false)}
                  />
                  <label htmlFor="import-all" style={{ fontSize: "0.875rem" }}>
                    Import all records
                  </label>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="radio"
                    id="import-new"
                    checked={enableCache}
                    onChange={() => onEnableCacheChange?.(true)}
                  />
                  <label htmlFor="import-new" style={{ fontSize: "0.875rem" }}>
                    Import new/modified only
                  </label>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      )}
    </Stack>
  );
};
